
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-property-by-locality",
      function () {
        return require("private-next-pages/sell-property-by-locality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-property-by-locality"])
      });
    }
  